/**
 * 环境配置
 * - 测试环境：地址已由后端提供
 * - 生产环境：地址暂未给出，预留位置（baseUrl 留空）
 * 切换方式：修改项目根目录 .env 中的 REACT_APP_ENV = test | prod
 */

const ENV = {
  test: {
    key: 'test',
    label: '测试环境',
    baseUrl: 'http://192.168.1.105:8081',
  },
  prod: {
    key: 'prod',
    label: '生产环境',
    baseUrl: '', // TODO: 生产环境地址待提供，配置后首页 / 测试按钮将自动切换到此地址
  },
};

// 当前环境：优先读取 .env 中的 REACT_APP_ENV，默认 test
const CURRENT_ENV_KEY = process.env.REACT_APP_ENV || 'test';
const CURRENT_ENV = ENV[CURRENT_ENV_KEY] || ENV.test;

// 允许通过 REACT_APP_API_BASE_URL 强制覆盖 baseUrl（最高优先级）
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || CURRENT_ENV.baseUrl || '';

/**
 * 全局 Mock 开关
 * - true ：全站业务接口（首页/产品/关于/联系/留言）直接返回 Mock 数据，
 *          不发起真实请求（联网调试前先用 Mock 保障页面展示）。
 * - false：业务接口走真实后端。
 * 注：右下角「接口测试」按钮不受影响，始终请求当前环境的真实地址。
 * 后端联调通过、需要接真实数据时改为 false。
 */
const USE_MOCK = true;

export { ENV, CURRENT_ENV_KEY, CURRENT_ENV, API_BASE_URL, USE_MOCK };
